import styled from 'styled-components';

export const Thumb = styled('div')`
  cursor: grab;
  top: 50%;
  width: 0px;
  height: 0px;
  &:after {
    content: ' ';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: 32px;
    height: 32px;
    background: rgba(47, 128, 237, 0.5);
    border: 2px solid rgba(47, 128, 237, 0.2);
    box-sizing: border-box;
    border-radius: 16px;
    margin-top: -16px;
    margin-left: -16px;
  }
  &:before {
    content: ' ';
    display: block;
    position: absolute;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background-color: #2f80ed;
    top: 0;
    left: 0;
    margin-top: -4px;
    margin-left: -4px;
  }
`;

interface PipProps {
  left?: number;
  offsets?: number;
  active?: boolean;
}

export const Pip = styled('div')<PipProps>`
  position: absolute;
  left: ${({ left }) => (left ? left : 0)}%;
  top: ${({ theme }) => -theme.x6spacePx}px;
`;
export const Label = styled('div')<PipProps>`
  ${({ theme }) => theme.typography.xSmall}
  position: absolute;
  color: ${({ active }) => (active ? '#666' : '#999')};
  z-index: 1;
  transform: translateX(-50%);
  left: ${({ offsets }) => (offsets ? offsets : 0)}px;
`;
export const Dot = styled('div')<PipProps>`
  display: block;
  z-index: 1;
  position: absolute;
  bottom: -2px;
  margin-left: -4px;
  top: 44px;
  width: ${({ theme }) => theme.x1spacePx}px;
  height: ${({ theme }) => theme.x1spacePx}px;
  border: 2px solid ${({ active }) => (active ? '#abe2fb' : '#e9e9e9')};
  background-color: #fff;
  cursor: pointer;
  border-radius: 50%;
`;

interface TrackProps {
  background: string;
}

export const Track = styled('div')<TrackProps>`
  top: 50%;
  height: 4px;
  margin-top: -2px;
  background: ${({ background }) => background};
`;
